import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { TextButton } from 'seagull';
import { useStore, useStoreActions } from '~/contexts';
import { selectors } from '~/store/state-selectors';
import styles from './TimeActivityActions.module.scss';
export const TimeActivityActions = (param)=>{
    let { showAddAll, relationshipId, handleAddAllTimeActivities } = param;
    const { logBI } = useStoreActions();
    const vendorId = useStore(selectors.user.businessId);
    const userId = useStore(selectors.user.id);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.actions,
        children: [
            showAddAll ? /*#__PURE__*/ _jsx(TextButton, {
                onClick: ()=>{
                    logBI(12015, {
                        vendorId,
                        userId
                    });
                    handleAddAllTimeActivities();
                },
                weight: "normal",
                underline: "none",
                testId: "add-all-time-activities",
                children: "Add all"
            }) : /*#__PURE__*/ _jsx("div", {}),
            /*#__PURE__*/ _jsx(RefreshTimeActivities, {
                relationshipId: relationshipId
            })
        ]
    });
};
export const RefreshTimeActivities = (param)=>{
    let { relationshipId } = param;
    const [isLoading, setIsLoading] = useState(false);
    const userId = useStore(selectors.user.id);
    const vendorId = useStore(selectors.user.businessId);
    const { logBI, fetchQboTimeActivities } = useStoreActions();
    return /*#__PURE__*/ _jsx(TextButton, {
        onClick: ()=>{
            logBI(12019, {
                vendorId,
                userId
            });
            setIsLoading(true);
            fetchQboTimeActivities(relationshipId).finally(()=>setIsLoading(false));
        },
        weight: "normal",
        disabled: isLoading,
        underline: "none",
        testId: "refresh-time-activities",
        children: "Refresh"
    });
};
